import { DrawerHeading, DrawerListSubHeader } from "../Drawer.styled";
import {
  MENU_COLLECTION_REQUIRED,
  PAGE_COLLECTION_REQUIRED,
} from "../../../constants/access";

import { DRAWER_MENU } from "../../../constants/menu";
import { Divider } from "@mui/material";
import { DrawerSectionProps } from "../../../types/DrawerSection";
import EnsureUserHasAccess from "../../../security/EnsureUserHasAccess";
import MenuItem from "../../Menu/MenuItem";
import { useTranslation } from "react-i18next";

const DataVisualization = ({ open }: DrawerSectionProps) => {
  const { t } = useTranslation();

  return (
    <EnsureUserHasAccess
      collections={MENU_COLLECTION_REQUIRED.DATA_VISUALIZATION} // This contains also the required collection for the SAV_DASHBOARD
      collectionStrategy="any"
      redirect={false}
    >
      <DrawerHeading sx={{ ...(open && { p: 0 }) }}>
        {open ? (
          <DrawerListSubHeader>{t("stats_label")}</DrawerListSubHeader>
        ) : null}

        <EnsureUserHasAccess
          collections={PAGE_COLLECTION_REQUIRED.SAV_DASHBOARD}
          redirect={false}
        >
          <MenuItem open={open} element={DRAWER_MENU.SAV_DASHBOARD} />
        </EnsureUserHasAccess>

        <EnsureUserHasAccess
          collections={PAGE_COLLECTION_REQUIRED.OVERVIEW}
          redirect={false}
        >
          <MenuItem open={open} element={DRAWER_MENU.OVERVIEW} />
        </EnsureUserHasAccess>

        <EnsureUserHasAccess
          collections={PAGE_COLLECTION_REQUIRED.ERROR_REPORT}
          redirect={false}
        >
          <MenuItem open={open} element={DRAWER_MENU.ERROR_REPORT} />
        </EnsureUserHasAccess>

        <EnsureUserHasAccess
          collections={PAGE_COLLECTION_REQUIRED.ACTIVITY}
          redirect={false}
        >
          <MenuItem open={open} element={DRAWER_MENU.ACTIVITY} />
        </EnsureUserHasAccess>
      </DrawerHeading>
      {!open ? <Divider /> : null}
    </EnsureUserHasAccess>
  );
};

export default DataVisualization;
